import { Autocomplete, Button, Checkbox, Dialog, DialogTitle, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { getDeletedClientGroups, restoreClientGroup } from "api/services/clients/clients";
import { getAllUsersInOrganzaition, getDeletedUsers } from "api/services/users";
import Loader from "components/Loader";
import Table, { ColumnType } from "components/Table";
import { snack } from "components/toast";
import { useConfirm } from "context/ConfirmDialog";
import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { ResType } from "types";
import { handleError } from "utils/handleError";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { exportDeletedClientsGroupPageReport } from "api/services/reports";
import SearchContainer from "components/SearchContainer";
import { getCountryCode } from "validations/phoneNumbr";
import { getCurrentFormattedDateTime } from "utils";
import { useUserData } from "context/UserProfile";
import { usePermissions } from "context/PermissionsProvider";
import { Permissions } from "data/permissons";
import PermissionDenied from "components/PemissionDenied";
import { SortDirection } from "data/constants";
import sortHandler from "components/Table/SortHandler";
import _ from "lodash";
import { StyledTextField } from "views/taskview/Details/Fields";
import LoadingButton from "components/LoadingButton";
import { useConfirmCancel } from "context/ConfirmDialogTwo";


function DeletedClientGroups(state) {

  const confirm = useConfirm();
  const confirmCancel = useConfirmCancel()
  const queryClient = useQueryClient();
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [clientsData, setClientData] = useState([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [search, setSearch] = useState('');
  const { data: userData } = useUserData();
  const [dataa, setDataa] = useState<any>({});;
  const [deleteClientOpen, setDeleteClientOpen] = useState(false);
  const { permissions } = usePermissions();
  const [sort, setSort] = useState<any>({});
  const { data, isLoading }: ResType = useQuery(["deleted-client-groups", {
    limit: pageCount,
    offset: page * pageCount,
    search: search,
    sort,
  }], getDeletedClientGroups, {
    onSuccess: (res) => {
      setClientData(res?.data[0]);
      setTotalCount(res?.data[1]);
    },
    onError: (err: any) => {
      if (!err?.error) {
        snack.error(`An error occurred while fetching deleted clients`);
      }
    }
  });

  const { mutate, isLoading: restoreLoading } = useMutation(restoreClientGroup, {
    onSuccess: () => {
      setDeleteClientOpen(false);
      setDataa({});
      snack.success("Clients Group Access Restored");
      queryClient.invalidateQueries("deleted-client-groups");
    },
    onError: (err: any) => {
      if (err && !err?.error) {
        snack.error(handleError(err));
      } else if (!err?.error) {
        snack.error(`An error occurred while restoring clients`);
      }
    },
  });

  const handleRestore = (client: any) => {
    const deletedIds = deletedUsers?.data?.[0]?.map((item: any) => item?.id);
    const taskMembersIds = client?.clientGroupManagers.map((item: any) => item?.id);
    const hasDeletedMember = deletedIds?.some((id: any) => taskMembersIds?.includes(id));
    const id = client.id;
    const clientGroupManagers = client?.clientGroupManagers;

    if (hasDeletedMember || !taskMembersIds.length) {
      setDeleteClientOpen(true);
      setDataa(client);
    } else {
      confirm({
        msg: "Are you sure you want to restore this clients Group ?",
        action: () => mutate({ id, clientGroupManagers }),
      });
    }
  };

  const { mutate: mutate1 } = useMutation(exportDeletedClientsGroupPageReport, {
    onSuccess: (res: any) => {
      const arr = new Uint8Array(res.data?.data);
      const blob = new Blob([arr], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const file = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      const formattedDateTime = getCurrentFormattedDateTime();
      link.href = file;
      link.download = `ATOM - Deleted Clients Group ${formattedDateTime}.xlsx`;
      link.click();
      snack.success("Exported successfully");
    },
    onError: (err: any) => {
      snack.error(err);
      snack.error(handleError(err));
    },
  });
  const handleExport = () => {
    mutate1({
      ...state,
    });

  }
  const handleSearch = (e) => {
    setSearch(e);
    setPage(0);
  }

  const { data: deletedUsers, isLoading: deletedUsersLoading }: ResType = useQuery(["deleted-users"], getDeletedUsers, {
    onSuccess: (res) => {
    },
    onError: (err: any) => {
      if (!err?.error) {
        snack.error(`An error occurred while fetching deleted users`);
      }
    }
  });

  const { data: users, isLoading: userLoading }: ResType = useQuery(
    "users",
    getAllUsersInOrganzaition
  );

  const handleSubmit = (event: any) => {
    event.preventDefault();
    const deletedIds = deletedUsers?.data?.[0]?.map((item: any) => item?.id);
    const taskMembersIds = dataa?.clientGroupManagers.map((item: any) => item?.id);
    const hasDeletedMember = deletedIds?.some((id: any) => taskMembersIds?.includes(id));
    const id = dataa?.id;
    const clientGroupManagers = dataa?.clientGroupManagers;

    if (hasDeletedMember) {
      snack.error("Deleted users are there in Client Group Manangers !");
    } else {
      if (!dataa.clientGroupManagers.length) {
        return snack.error("Please add atleast one Client Group Manager !")
      } else {
        confirm({
          msg: "Are you sure you want to restore this clients Group ?",
          action: () =>
            mutate({ id, clientGroupManagers })
        });
      }
    }
  }

  const defaultColumns: Array<ColumnType> = [
    {
      key: "clientId",
      title: "Client Group ID",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
    },
    {
      key: "displayName",
      title: "Display Name",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
    },
    {
      key: "mobileNumber",
      title: "Mobile Number",
      render: (row: any) => <Typography>{`+${getCountryCode(row?.countryCode) || 91} ${row?.mobileNumber}`}</Typography>,
    },
    {
      key: "email",
      title: "Email ID",
    },
  ]

  if (userData?.role?.name === "Admin" || permissions.includes(Permissions.RESTORE_DELETED_CLIENT_GROUPS)) {
    defaultColumns.push({
      key: "Action",
      title: "Action",
      render: (item: any) => {
        return (
          <Button
            size="small"
            variant="contained"
            color="secondary"
            onClick={() => handleRestore(item)}
          >
            Restore
          </Button>
        );
      },
    })
  }
  const [columns, setColumns] = useState(_.cloneDeep(defaultColumns));
  const handleSort = (v: any) => {
    sortHandler({
      key: v.key,
      columns,
      sortState: sort,
      setSortState: setSort,
      setColumns: setColumns,
    });
  };
  const handleDialogClode = () => {
    setDeleteClientOpen(false);
    setDataa({});
  }
  if (isLoading) return <Loader />;

  if (userData?.role?.name !== "Admin" && !permissions.includes(Permissions.VIEW_DELETED_CLIENT_GROUPS)) {
    return (
      <PermissionDenied />
    );
  }

  return (
    <Box>
      <Box display="flex" gap={3} justifyContent="space-between" mt={2} mr={2} mb={1}>
        <Typography variant="subtitle1" px={2}>
          Deleted Client Groups
        </Typography>
        <SearchContainer
          debounced
          value={search}
          placeHolder="Search by Display Name | Email"
          onChange={handleSearch}
        />
        <Button variant="outlined" color="secondary" onClick={handleExport}
          startIcon={<FileDownloadOutlinedIcon />}     >
          Export
        </Button>
      </Box>
      <Box px={1}>
        <Table
          sx={{ mb: 0, pb: 0, height: '520px' }}
          loading={isLoading}
          data={clientsData || []}
          columns={columns}
          sortHandler={handleSort}
          pagination={{ totalCount, page, setPage, pageCount, setPageCount }}
        />
      </Box>
      <Dialog maxWidth={"md"} open={deleteClientOpen} onClose={() => handleDialogClode()}>
        <DialogTitle>To Restore Update Deleted Client Group Managers</DialogTitle>
        <form onSubmit={(e) => handleSubmit(e)} style={{ padding: "20px" }}>
          <Autocomplete
            multiple
            disableCloseOnSelect
            options={[{ id: "selectAll", fullName: "Select All" }, ...(users?.data || [])]}
            getOptionLabel={(option) => option.fullName || ""}
            value={dataa?.clientGroupManagers || []}
            onChange={(_, newSelected) => {
              const isAllSelected = dataa?.clientGroupManagers?.length === users?.data?.length;

              if (newSelected.some((item) => item.id === "selectAll")) {
                setDataa({
                  ...dataa,
                  clientGroupManagers: isAllSelected ? [] : users?.data || [],
                });
              } else {
                setDataa({ ...dataa, clientGroupManagers: newSelected });
              }
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderOption={(props, option, { selected }) => {
              const isSelectAll = option.id === "selectAll";
              const isAllSelected = dataa?.clientGroupManagers?.length === users?.data?.length;

              return (
                <li {...props} key={option.id} onClick={(e) => e.stopPropagation()}>
                  <Checkbox
                    checked={isSelectAll ? isAllSelected : (dataa?.clientGroupManagers || []).some((o) => o.id === option.id)}
                    onChange={() => {
                      if (isSelectAll) {
                        setDataa({
                          ...dataa,
                          clientGroupManagers: isAllSelected ? [] : users?.data || [],
                        });
                      } else {
                        const exists = (dataa?.clientGroupManagers || []).some((o) => o.id === option.id);
                        const updatedList = exists
                          ? (dataa?.clientGroupManagers || []).filter((o) => o.id !== option.id)
                          : [...(dataa?.clientGroupManagers || []), option];

                        setDataa({
                          ...dataa,
                          clientGroupManagers: updatedList,
                        });
                      }
                    }}
                    style={{ marginRight: 8 }}
                  />
                  {option.fullName}
                </li>
              );
            }}
            renderInput={(params) => (
              <StyledTextField
                {...params}
                label="Client Group Managers"
                variant="outlined"
                size="small"
                fullWidth
              />
            )}
          />
          <Box display="flex" justifyContent="flex-end" mt={2} gap={2}>
            <LoadingButton
              loading={restoreLoading}
              disabled={restoreLoading}
              fullWidth
              loadingColor="white"
              title="Update"
              color="secondary"
              type="submit"
            />
          </Box>
        </form>
      </Dialog>
    </Box>
  );
}

export default DeletedClientGroups;
